'use es6';

import http from 'hub-http/clients/noAuthApiClient';
const fetchZuoraOutageStatus = hubId => {
  const appendHubId = hubId ? `?hubId=${hubId}` : '';
  return http.get(`/fintech-outages/v1/zuora${appendHubId}`);
};
export { fetchZuoraOutageStatus };